import React from "react";

// Icon components
const AccountIcon = ({ size = 20, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const LockIcon = ({ size = 20, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const EyeIcon = ({ size = 20, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = ({ size = 20, color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const LoginForm = ({ errors, fieldFocus, setFieldFocus, colors }) => {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className="flex flex-col gap-4">
      <div>
        <label
          htmlFor="username"
          className="block text-sm font-semibold mb-1.5"
          style={{ 
            color: fieldFocus.username ? colors.primary : colors.text 
          }}
        >
          Username or email
        </label>
        <div
          className="flex items-center rounded-xl px-4 h-14 border transition-all"
          style={{
            backgroundColor: colors.card,
            borderColor: errors.username 
              ? colors.error 
              : fieldFocus.username 
                ? colors.primary 
                : 'transparent',
            borderWidth: '1.5px',
          }}
        >
          <AccountIcon 
            size={20} 
            color={fieldFocus.username ? colors.primary : colors.secondary} 
          />
          <input
            autoFocus
            required
            id="username"
            name="username"
            type="text"
            placeholder="Enter username or email"
            className="flex-1 ml-3 bg-transparent outline-none text-base"
            style={{ 
              color: colors.text,
            }}
            onFocus={() => setFieldFocus(prev => ({ ...prev, username: true }))}
            onBlur={() => setFieldFocus(prev => ({ ...prev, username: false }))}
          />
        </div>
        {errors.username && (
          <div className="text-xs mt-1.5 ml-1" style={{ color: colors.error }}>
            {errors.username}
          </div>
        )}
      </div>

      <div>
        <label
          htmlFor="password"
          className="block text-sm font-semibold mb-1.5"
          style={{ 
            color: fieldFocus.password ? colors.primary : colors.text 
          }}
        >
          Password
        </label>
        <div
          className="flex items-center rounded-xl px-4 h-14 border transition-all"
          style={{
            backgroundColor: colors.card,
            borderColor: errors.password 
              ? colors.error 
              : fieldFocus.password 
                ? colors.primary 
                : 'transparent',
            borderWidth: '1.5px',
          }}
        >
          <LockIcon 
            size={20} 
            color={fieldFocus.password ? colors.primary : colors.secondary} 
          />
          <input
            required
            id="password"
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter your password"
            className="flex-1 ml-3 bg-transparent outline-none text-base"
            style={{ 
              color: colors.text,
            }}
            onFocus={() => setFieldFocus(prev => ({ ...prev, password: true }))}
            onBlur={() => setFieldFocus(prev => ({ ...prev, password: false }))}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="ml-2 p-1 hover:opacity-70 transition-opacity"
            style={{ color: colors.secondary }}
          >
            {showPassword ? (
              <EyeOffIcon size={20} color={colors.secondary} />
            ) : (
              <EyeIcon size={20} color={colors.secondary} />
            )}
          </button>
        </div>
        {errors.password && (
          <div className="text-xs mt-1.5 ml-1" style={{ color: colors.error }}>
            {errors.password}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginForm;
